import { readStored, writeStored } from './storage';

const AUTO_SUBMIT_KEY = 'lingo:autoSubmit';

/* Defaults to on, which is how the game has always behaved. */
export const resolveAutoSubmit = (): boolean => readStored(AUTO_SUBMIT_KEY) !== 'false';

export const persistAutoSubmit = (autoSubmit: boolean): void => {
  writeStored(AUTO_SUBMIT_KEY, autoSubmit ? 'true' : 'false');
};
